import BrokenImageIcon from "@mui/icons-material/BrokenImage";
import { useCallback, useEffect, useState } from "react";
import { useDispatch } from "react-redux";
import AmplifyAPIWrapper, { INotifications } from "src/API/AmplifyAPIWrapper";
import { getThumbnail } from "src/redux/actions/ContentManagement/ContentManagement.Actions";
import DeniedImage from "src/themes/assets/denied.svg?react";

interface IContentThumbnailProps {
  size: number;
  // attachmentURL?: any;
  contentId: string;
  fileType: string;
  fileName: string;
}

export const ContentThumbnail = (props: IContentThumbnailProps): JSX.Element => {
  const { size, contentId, fileType, fileName } = props;
  const [thumbnail, setThumbnail] = useState<string>(!fileType && !fileName ? "NOATTACHEDFILE" : "");

  const dispatch = useDispatch();
  //if there is no thumbnail fetch the image from the backend
  useEffect(() => {
    if (thumbnail) {
      return;
    }
    const getThumb = async (): Promise<void> => {
      const thumbnail = await getThumbnail(contentId);
      //Check if this was a 403 Unauthorized
      if (thumbnail?.status === 403) {
        setThumbnail("UNAUTHORIZED");
        return;
      }

      //thumbnail is in binary form now so
      //createObjectURL - creates a DOMString containing a URL representing the object given in the parameter.
      //the URL lifetime is tied to the document in the window on which it was created
      try {
        const urlForImage = URL.createObjectURL(thumbnail);
        setThumbnail(urlForImage);
      } catch (e) {
        return;
      }
    };
    getThumb();
  }, [contentId, thumbnail]);

  const getImage = useCallback((): JSX.Element => {
    //Look into changing the imagine the fetch thumbnail failed because of permissions
    if (thumbnail === "UNAUTHORIZED") {
      return <DeniedImage width={size} height={size} style={{ color: "black" }} />;
    } else if (thumbnail === "NOATTACHEDFILE") {
      return <div></div>;
    } else if (!thumbnail) {
      return <BrokenImageIcon width={size} height={size} />;
    } else {
      return <img src={thumbnail} alt="thumbnail" width={size} height={size} />;
      // return <img src={attachmentURL.thumbnailURL} width={size} height={size} alt="thumbnail" />;
    }
  }, [size, thumbnail]);

  //gets the url from the backend end based on the content's id and filetype
  //uses the url to kick off a download from S3
  const downloadFile = useCallback(async () => {
    const notifications: INotifications = {
      dispatch: dispatch,
      infoMessage: "Downloading file...",
      successMessage: "File downloaded.",
      errorMessage: "Error: Unable to download file",
    };
    const response: any = await AmplifyAPIWrapper.Get<any>(`/fileURL/${contentId}/${fileType}`, notifications);
    if (!response?.url) return;
    const downloadLink = document.createElement("a");
    // Add the element to the DOM - to stop the wws disconnect in firefox
    document.body.appendChild(downloadLink);
    downloadLink.href = response.url;
    downloadLink.target = "_blank";
    downloadLink.download = fileName;
    downloadLink.click();
    return response.url;
  }, [contentId, fileType, fileName, dispatch]);

  return (
    <div className="thumbnail">
      <div onClick={downloadFile} style={{ cursor: "pointer" }}>
        {getImage()}
      </div>
    </div>
  );
};
